import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientClaim, createClientClaim, deleteClientClaim, updateClientClaim } from "../slice/clientPanelClaimSlice";
import { toast } from "react-toastify";

const ClientClaims = () => {

    const dispatch = useDispatch();
    const [showAddModal, setShowAddModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
    const { clientsClaim } = useSelector((state) => state.clientClaim);
    const [editingClaimId, setEditingClaimId] = useState(null);
    const [existingFileName, setExistingFileName] = useState(null);
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        amount: "",
        invoice_date: "",
        invoice_file: null, // for file
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({ ...prev, [name]: files[0] }));
    };

    const clientToken = localStorage.getItem("client_access_token");

    useEffect(() => {
        dispatch(getClientClaim(clientToken));
    }, [dispatch]);

    //   console.log("clientsClaim", clientsClaim);

    const sortedData = [...(Array.isArray(clientsClaim) ? clientsClaim : [])].sort((a, b) => {
        if (sortConfig.column === null) return 0;

        const key = sortConfig.column;
        const valA = a[key] ?? "";
        const valB = b[key] ?? "";

        if (!isNaN(valA) && !isNaN(valB)) {
            return sortConfig.direction === "asc"
            ? valA - valB
            : valB - valA;
        } else {
            return sortConfig.direction === "asc"
            ? valA.toString().localeCompare(valB.toString())
            : valB.toString().localeCompare(valA.toString());
        }
    });

    const handleSort = (columnKey) => {
        let direction = "asc";
        if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ column: columnKey, direction });
    };

    const handleAddClaimModel = () => {
        setFormData({
        first_name: "",
        last_name: "",
        amount: "",
        invoice_date: "",
        invoice_file: null,
      });
      setShowAddModal(true);
    };

   const handleCloseClaimModal = () => {
  setShowAddModal(false);
  setEditingClaimId(null);
};


    const handleSubmit = async (e) => {
  e.preventDefault();

  const claimData = {
    ...formData,
    status: "pending",
  };

  let result;
  if (editingClaimId) {
    result = await dispatch(updateClientClaim({ id: editingClaimId, formData: claimData, token: clientToken }));
  } else {
    result = await dispatch(createClientClaim({ formData: claimData, token: clientToken }));
  }

  if (result.meta.requestStatus === "fulfilled") {
    toast.success(`Claim ${editingClaimId ? "updated" : "created"} successfully!`);
    dispatch(getClientClaim(clientToken));
    setShowAddModal(false);
    setEditingClaimId(null); // Reset edit state
  } else {
    toast.error(`Claim ${editingClaimId ? "update" : "creation"} failed`);
  }
};

    const handleDelete = async (id) => {
  const confirm = window.confirm("Are you sure you want to delete this claim?");
  if (!confirm) return;

  const result = await dispatch(deleteClientClaim({ id, token: clientToken }));
  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Claim deleted successfully!");
  } else {
    toast.error("Failed to delete claim");
  }
};
const handleEdit = (claim) => {
  setFormData({
    first_name: claim.first_name,
    last_name: claim.last_name,
    amount: claim.amount,
    invoice_date: claim.invoice_date,
    invoice_file: null, // new file can be selected
  });
  setExistingFileName(claim.invoice_file); // <-- store current file name
  setEditingClaimId(claim.id);
  setShowAddModal(true);
};




    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
                        Claim
                        <button className="btn btn-danger ms-auto py-2" onClick={handleAddClaimModel}>
                            <i className="fa fa-user-plus me-1"></i> 
                            Add claim
                        </button>
                    </h4>
                    <table className="table table-striped table-bordered align-middle" id="servicesTable">
                        <thead>
                            <tr>
                                <th className="font-weight-semibold" onClick={() => handleSort("first_name")}>First name <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold" onClick={() => handleSort("last_name")}>Last name<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold" onClick={() => handleSort("amount")}>Amount <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold" onClick={() => handleSort("invoice_date")}>Invoice Date <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold" onClick={() => handleSort("status")}>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold" onClick={() => handleSort("invoice_file")}>Invoice File <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                <th className="font-weight-semibold">Actions <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedData.map((claim, index) => (
                                <tr key={claim.id || index}>
                                    <td>{claim.first_name}</td>
                                    <td>{claim.last_name}</td>
                                    <td>{claim.amount}</td>
                                    <td>{claim.invoice_date}</td>
                                    <td>{claim.status}</td>
                                    <td>
                                        {claim.invoice_file ? (
                                            <a
                                            href={`${process.env.REACT_APP_CLIENT_CLAIM_BACKEND_URL}/${claim.invoice_file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            >
                                            {claim.invoice_file}
                                            </a>
                                        ) : (
                                            "No file"
                                        )}
                                    </td>
                                    <td>
                                        <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(claim)}>Edit</button>
                                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(claim.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {showAddModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Add Claim</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseClaimModal} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="row">
                                            <div className="mb-3 col-md-6">
                                                <label htmlFor="first_name" className="form-label text-primary mb-1 font-weight-semibold">
                                                    First name:
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="first_name"
                                                    name="first_name"
                                                    value={formData.first_name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <label htmlFor="last_name" className="form-label text-primary mb-1 font-weight-semibold">
                                                    Last name:
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="last_name"
                                                    name="last_name"
                                                    value={formData.last_name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <label htmlFor="amount" className="form-label text-primary mb-1 font-weight-semibold">
                                                    Amount:
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="amount"
                                                    name="amount"
                                                    value={formData.amount}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <label htmlFor="invoice_date" className="form-label text-primary mb-1 font-weight-semibold">
                                                    Invoice date:
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="invoice_date"
                                                    name="invoice_date"
                                                    value={formData.invoice_date}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <label className="form-label text-primary mb-1 font-weight-semibold required">Upload Image</label>
                                                <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                                                {/* Upload Field */}
                                                    <div className="uploadfield flex-fill">
                                                        <div className="custom-file-upload position-relative">
                                                            <button
                                                                type="button"
                                                                className="upload-btn btn btn-custom-primary position-absolute"
                                                                onClick={() => document.getElementById('invoice_file')?.click()}
                                                            >
                                                                Upload Files
                                                            </button>
                                                            <input
                                                                type="file"
                                                                name="invoice_file"
                                                                id="invoice_file"
                                                                onChange={handleFileChange}
                                                            />
                                                        </div>
                                                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
  {formData.invoice_file?.name ? (
    formData.invoice_file.name
  ) : existingFileName ? (
    <a
      href={`${process.env.REACT_APP_CLIENT_CLAIM_BACKEND_URL}/${existingFileName}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {existingFileName}
    </a>
  ) : (
    "No file chosen"
  )}
</div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseClaimModal}>Close</button>
                                    <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleSubmit}>Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ClientClaims;